import { render, staticRenderFns } from "./ConfirmationInscriptionUm6p.vue?vue&type=template&id=1adff7e4&scoped=true"
import script from "./ConfirmationInscriptionUm6p.vue?vue&type=script&lang=js"
export * from "./ConfirmationInscriptionUm6p.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationInscriptionUm6p.vue?vue&type=style&index=0&id=1adff7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adff7e4",
  null
  
)

export default component.exports